export default __webpack_public_path__ + "static/media/bezel_set.7beff00c.png";